module.exports = __webpack_public_path__ + "static/model-keycap-foreground-15adcb1ad42193ea0d1de601b4903165.png";